import {
  ROOT,
  RELATION_GET_ALL,
  RELATION_ADD_SALE_PACKAGE,
  RELATION_REMOVE_SALE_PACKAGE,
  UPDATE_ROOM_STATUS,
  UPDATE_PRICE,
  UPDATE_SPECIAL_PRICE,
  UPDATE_SPECIAL_PRICE_ADULT,
  UPDATE_SPECIAL_PRICE_CHILD,
  UPDATE_SPECIAL_PRICE_BABY,
  DELETE_SPECIAL_PRICE,
  DELETE_SPECIAL_PRICE_EXTRA_ADULT,
  DELETE_SPECIAL_PRICE_EXTRA_CHILD,
  DELETE_SPECIAL_PRICE_EXTRA_BABY,
  UPDATE_EXTRA_PRICE,
  DELETE_EXTRA_PRICE,
  MASS_UPDATE_EXTRA_PRICE,
  UPDATE_SPECIAL_PRICE_EXTRA,
  DELETE_SPECIAL_PRICE_BULK,
  DELETE_EXTRA_SPECIAL_PRICE,
  MOBILE_AVAILABILITY,
  UPDATE_STOP_SELL_DAY,
  GET_RATE_PLAN_BY_CATEGORY,
  GET_ROOM_TYPE_BY_CATEGORY,
  UPDATE_SPECIAL_PRICE_ROOM,
  DASHBOARD_RMS,
  DASHBOARD_RMS_STOP_SELL,
  DASHBOARD_RMS_DETAIL_DAY,
  DASHBOARD_RMS_DETAIL_DAY_STOP_SELL,
  GET_RESTRICTION_BY_ROOM_RATE_API,
  GET_ROOM_DEFAULT_WITH_ALL_RELATION,
  DASHBOARD_RMS_DETAIL_DAY_DU,
  DASHBOARD_RMS_DETAIL_DAY_A
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getAllSaleRoom(data, signal = null) {
  return fetch(ROOT + GET_ROOM_DEFAULT_WITH_ALL_RELATION, requestOptions.post(data, signal))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getRestrictionByRoomRate(data, signal = null) {
  return fetch(ROOT + GET_RESTRICTION_BY_ROOM_RATE_API, requestOptions.post(data, signal))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function dashboardRms(data) {
  return fetch(ROOT + DASHBOARD_RMS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function dashboardRmsStopSell(data) {
  return fetch(ROOT + DASHBOARD_RMS_STOP_SELL, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function dashboardRmsDetailDay(data) {
  return fetch(ROOT + DASHBOARD_RMS_DETAIL_DAY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function dashboardRmsDetailDayA(data) {
  return fetch(ROOT + DASHBOARD_RMS_DETAIL_DAY_A, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function dashboardRmsDetailDayDU(data) {
  return fetch(ROOT + DASHBOARD_RMS_DETAIL_DAY_DU, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detailRmsStopSell(data) {
  return fetch(ROOT + DASHBOARD_RMS_DETAIL_DAY_STOP_SELL, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllRelation(data, signal = null) {
  return fetch(ROOT + RELATION_GET_ALL, requestOptions.post(data, signal))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function addSalePackage(data) {
  return fetch(ROOT + RELATION_ADD_SALE_PACKAGE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function removeSalePackage(data) {
  return fetch(ROOT + RELATION_REMOVE_SALE_PACKAGE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateRoomStatus(data) {
  return fetch(ROOT + UPDATE_ROOM_STATUS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updatePrice(data) {
  return fetch(ROOT + UPDATE_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateExtraPrice(data) {
  return fetch(ROOT + UPDATE_EXTRA_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteExtraPrice(data) {
  return fetch(ROOT + DELETE_EXTRA_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSpecialPrice(data) {
  return fetch(ROOT + UPDATE_SPECIAL_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteSpecialPrice(data) {
  return fetch(ROOT + DELETE_SPECIAL_PRICE_BULK, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSpecialPriceExtra(data) {
  return fetch(ROOT + UPDATE_SPECIAL_PRICE_EXTRA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSpecialPriceAdult(data) {
  return fetch(ROOT + UPDATE_SPECIAL_PRICE_ADULT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSpecialPriceChild(data) {
  return fetch(ROOT + UPDATE_SPECIAL_PRICE_CHILD, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSpecialPriceBaby(data) {
  return fetch(ROOT + UPDATE_SPECIAL_PRICE_BABY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function removeSpecialPrice(data) {
  return fetch(ROOT + DELETE_SPECIAL_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function removeSpecialPriceExtraAdult(data) {
  return fetch(ROOT + DELETE_SPECIAL_PRICE_EXTRA_ADULT, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function removeSpecialPriceExtraChild(data) {
  return fetch(ROOT + DELETE_SPECIAL_PRICE_EXTRA_CHILD, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function removeSpecialPriceExtraBaby(data) {
  return fetch(ROOT + DELETE_SPECIAL_PRICE_EXTRA_BABY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function massUpdateExtraPrice(data) {
  return fetch(ROOT + MASS_UPDATE_EXTRA_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function deleteSpecialPriceExtra(data) {
  return fetch(ROOT + DELETE_EXTRA_SPECIAL_PRICE, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAvailability(data) {
  return fetch(ROOT + MOBILE_AVAILABILITY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateStopsellDay(data) {
  return fetch(ROOT + UPDATE_STOP_SELL_DAY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllRatePlanByCategory() {
  return fetch(ROOT + GET_RATE_PLAN_BY_CATEGORY, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllRoomTypeByCategory() {
  return fetch(ROOT + GET_ROOM_TYPE_BY_CATEGORY, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateSpecialPriceRoom(data) {
  return fetch(ROOT + UPDATE_SPECIAL_PRICE_ROOM, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion
export const sale_room = {
  dashboardRmsDetailDayA,
  dashboardRmsDetailDayDU,
  getRestrictionByRoomRate,
  getAllSaleRoom,
  detailRmsStopSell,
  dashboardRmsDetailDay,
  dashboardRmsStopSell,
  dashboardRms,
  updateSpecialPriceRoom,
  getAllRelation,
  updateRoomStatus,
  addSalePackage,
  removeSalePackage,
  updatePrice,
  updateSpecialPrice,
  updateSpecialPriceAdult,
  updateSpecialPriceChild,
  updateSpecialPriceBaby,
  removeSpecialPrice,
  removeSpecialPriceExtraAdult,
  removeSpecialPriceExtraChild,
  removeSpecialPriceExtraBaby,
  updateExtraPrice,
  deleteExtraPrice,
  massUpdateExtraPrice,
  updateSpecialPriceExtra,
  deleteSpecialPrice,
  deleteSpecialPriceExtra,
  getAvailability,
  updateStopsellDay,
  getAllRatePlanByCategory,
  getAllRoomTypeByCategory
};
